<template lang="pug">
  .welcome-customer
    TransitionExpand
      .expiring-soon.text-center(v-if="expiringSoon")
        .xs-f-small.lg-f-small.max-at-tweak
          i.icon-warning
          | Your credit card ending in {{ expiringSoon.ccNum }} expires in {{ expiringSoon.expiresIn }} days.&nbsp;
          span(@click="editPaymentModal(expiringSoon)").clickable.underline.color-mr-purple Update Now

    .active-subscriber(v-if="boxesUsed && cdata.bestColorMatch")
      .a-box-xs-1x1.a-box-sm-2x1.a-box-md-2x1
        .a-box-content
          img-box(media-id="6187")

      .a-box-content
        .xs-12.sm-6.md-6.lg-6.full-height.text-center
          .xs-12.v-center
            .xs-12.name
              p.xs-f-small.lg-f-small.max-at-tweak.color-slate Welcome back,
              p.xs-f-medium.lg-f-large.max-at-tweak.upper {{ welcomeName }}

            .xs-5.xs-offset-1
              p.xs-12.xs-f-small.lg-f-small.max-at-tweak.color-purple.bold {{ memberSince | moment('YYYY') }}
              p.xs-f-xsmall.lg-f-small.max-at-tweak.color-slate {{ memberOrClient }} since

            .xs-5.text-center
              p.xs-12.xs-f-small.lg-f-small.max-at-tweak.color-purple.bold {{ boxesUsed }}
              p.xs-f-xsmall.lg-f-small.max-at-tweak.color-slate boxes used

    .inactive-subscriber(v-else)
      .a-box-xs-1x2.a-box-md-2x1
        .a-box-content
          img-box(media-id="6203")

      .a-box-content
        .xs-12.md-6.lg-6.md-offset-5.full-height.text-center
          .xs-12.find-your-shade
            .xs-12.name
              p.xs-f-small.lg-f-small.max-at-tweak.color-slate Welcome back,
              p.xs-f-medium.lg-f-large.max-at-tweak.upper(data-mr-ass="welcome-name") {{ welcomeName }}
            .xs-12
              .xs-f-xmedium.lg-f-large.max-at-tweak.bold.upper Salon gorgeous color
            .xs-12
              p.xs-f-xxxgrande.max-at-tweak.lovely-script.color-mr-blue at home

            .xs-12
              a(href="/shop/hair-color?rectype=color" data-mr-ass="perfect-shade-cta").mr-btn.xs-f-xsmall.max-at-tweak {{cdata.hasBeautyProfile && cdata.bestColorMatch ? 'See my perfect shade' : 'Find your perfect shade'}}
  
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import SectionTitle from "../../../SectionTitle";
  import TransitionExpand from "../../../TransitionExpand";

  export default {
    name: "WelcomeCustomer",
    components: {
      TransitionExpand,
      SectionTitle
    },

    computed: {
      ...mapState('customer', [
        'info',
        'cdata'
      ]),

      ...mapGetters('customer', [
        'boxesUsed',
        'memberSince',
        'isColorSubscriber'
      ]),

      ...mapGetters('payments', [
        'expiringSoon'
      ]),

      welcomeName() {
        return this.info.first_name || "Beautiful";
      },

      memberOrClient() {
        return this.isColorSubscriber ? 'member' : 'client';
      }
    },

    mounted() {
      this.$store.dispatch('payments/initPaymentProfiles');
      this.$store.dispatch('addressBook/initAddresses');
    },

    methods: {
      ...mapActions('payments', [
        'initPaymentProfiles',
        'initAddresses',
        'editPaymentModal'
      ])
    }
   }
</script>

<style scoped lang="stylus">
  .welcome-customer
    > div
      position relative

    .expiring-soon
      background-color bg-color-error
      padding 1.5em

    .v-center
      top 45%

    .find-your-shade
      padding-top 25%

    .name
      padding-bottom 1.5em

    @media mq-mobile
      .v-center
        top 25%

      .find-your-shade
        padding-top 7%

    @media mq-tablet
      .find-your-shade
        padding-top 12%

</style>
